/**
 * A plain-text file, shown as the characters it holds.
 *
 * Monospaced and wrapped rather than scrolled sideways: the lines of a log or a subtitle file
 * carry no layout, so a horizontal scrollbar would only hide the ends of them. Long unbroken
 * runs — a URL, a base64 blob — break inside the word rather than widening the column past it.
 */

import { PREVIEW_READING_COLUMN_CLASS } from "./reading-column";

export function TextPreviewBody({ text }: { text: string }) {
  return (
    <div className={PREVIEW_READING_COLUMN_CLASS}>
      <pre
        className="whitespace-pre-wrap break-words font-mono text-[13px]/relaxed text-foreground"
        data-testid="document-preview-text"
      >
        {text}
      </pre>
    </div>
  );
}
